import { Component, inject, OnInit } from '@angular/core';
import { PpmService } from '../ppm.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TaskHistory } from '@/types';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { getPpmTaskHistoryDataTableStructure } from './utils/ppm-task-history.data-table-object';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';

@Component({
  selector: 'sm-task-history',
  imports: [PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './task-history.component.html',
  styleUrl: './task-history.component.scss',
})
export class PpmTaskHistoryComponent implements OnInit {
  ppmService = inject(PpmService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);

  breadcrumb = [
    {
      label: 'ppm.pages.current_plans',
      routerLink: ['/ppm-current-plans'],
    },
    {
      label: 'ppm.pages.task_history',
      routerLink: ['/ppm-task-history'],
    },
  ];

  processInstanceId = this.activatedRoute.snapshot.params['processInstanceId'];

  loading = true;
  data: TaskHistory[] = [];
  datatableObject: DynamicDataTable = getPpmTaskHistoryDataTableStructure({
    translate: (key: string) => this.translate.instant(key),
  });

  ngOnInit(): void {
    if (!this.processInstanceId) return;
    this.ppmService.getPpmTaskHistory(this.processInstanceId).subscribe(history => {
      this.data = history;
      this.loading = false;
    });
  }
}
